// extracted by mini-css-extract-plugin
module.exports = {"loadingStimulator":"loading_container_loadingStimulator__3WTz3","loader":"loading_container_loader__2rL1z","spin":"loading_container_spin__S_DU9"};